export const appApiUrls = {
  auth: {
    checkUserPhoneNo: '/cualitywork/ext-user-details',
    logIn: '/auth/v3/login',
    logOut: '/auth/v3/logout',
    verifyOTP: '/auth/v3/verify-login-otp',
    sendOTP: '/cualitywork/send-login-otp',
    userWelcome: '/cualitywork/emp-welcome-profile',
    setPasscode: '/cualitywork/update-passcode',
    setLanguage: '/user/language',
    authUser: '/cualitywork/auth-user'
  },
  config: {
    orgConfig: '/org/config',
    settings: '/cualitywork/organization-config',
    organizations: '/organizations',
    taskSettings: '/orgSetup/task-settings',
    attendanceSettings: '/orgSetup/attendance-settings',
    appSettings: '/orgSetup/empapp-settings',
    extendUseCase: '/orgSetup/extend-usecase',
    allUseCases: '/orgSetup/extend-usecase',
    questionnaireForm: '/orgSetup/dynamic-forms'
  },
  kyc: {
    verifyPan: '/kyc/verify-pan',
    aadhaarOtp: '/kyc/aadhaar/otp',
    aadhaarVerify: '/kyc/aadhaar/verify'
  },
  dashboard: {
    checkInStatus: '/user/v2/checkIn',
    postCheckInStatus: '/user/v3/checkIn',
    geoFence: '/user/v2/geofence',
    dailyAttendance: '/cualitywork/daily-attendance',
    caseAnalytics: '/collection/cases/analytics/counts',
    caseStatusAnalytics: '/collection/cases/stats/collected-amount',
    taskAnalytics: '/task/emp/stats',
    caseStats: '/collection/cases/analytics/emp',
    saveLocation: '/user/v2/location'
  },
  attendance: {
    attendanceV2: '/user/v2/attendance',
    attendance: '/user/attendance',
    location: '/user/v2/location'
  },
  task: {
    tasks: '/task/emp',
    task: '/task',
    collections: '/collection/case/tasks',
    collection: '/collection/case/task',
    collectionCases: '/collection',
    case: '/collection/case',
    updateCollection: '/collection/case',
    updateTask: '/task',
    createCollection: '/collection/case/task',
    createTask: '/task',
    userLocation: '/user/v2/location',
    postLocationTimeSeries: '/location-time-series',
    photo: '/selfie',
    audio: '/audio',
    otp: '/otp/generate',
    otpVerification: '/otp/verify',
    meetingAttachment: '/add/meeting/attachment',
    steps: '/task/steps',
    whatsappTemplates: '/whatsapp/templates/assign',
    sendTemplate: '/whatsapp/customer-notification',
    entity: '/collection/entities',
    createCase: '/collection'
  },
  customer: {
    customers: '/customers',
    customer: '/customer',
    createCustomer: '/customer',
    updateCustomer: '/customer'
  },
  user: {
    getUser: '/user',
    users: '/v2/users',
    usersV3: '/v3/users',
    profile: '/cualitywork/emp-profile',
    profilePic: '/profile',
    employeeDetails: '/user/employeeDetails',
    userAttachment: '/add/user/documents',
    employmentDetails: '/emp/employment-details',
    leaveQuota: '/orgSetup/org-leaves',
    updateLeaveQuota: '/emp/leave/quota',
    addNewLeaveQuota: '/emp/leave/request',
    leaveHistory: '/emp/leave/requests',
    withdrawLeaveRequest: '/emp/leave/request',
    locationOverview: '/user/v2/location',
    locationTimeSeries: '/location-time-series',
    notifications: '/notifications'
  },
  claim: {
    customReimbursements: '/orgSetup/custom-reimbursement',
    userReimbursements: '/orgSetup/reimbursement/user',
    allReimbursements: '/orgSetup/reimbursement',
    submitReimbursement: '/orgSetup/reimbursement',
    updateReimbursement: '/orgSetup/reimbursement',
    uploadDocument: '/reimbursement/document'
  }
}
